
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M506.6 256c-52.3 0-72 46.5-87.3 27.5-20.1-25.1-2-107.2 3.5-131.9-34.2 6.4-137.2 24.3-163.8 2.2-16.6-13.8 31.3-43.5 31.3-86.4C290.3 26 256.4 0 214.8 0c-43.6 0-84.8 25.6-84.8 68.8 0 53 45.9 71.6 24.4 88.6C126 179.8 35.3 160.5 0 152v345.3c33.3 8 70.7 14.6 106.2 14.6 42.3 0 85.8-11.8 85.8-54.1 0-29.3-32-40.8-32-73.9 0-24.4 22.5-32 47-32C245.7 352 256 372.1 256 384c0 28.8-34.3 36.3-34.3 76.6 0 13.7 5 25.4 14.5 33.8 35.2 31.1 106.7 6.3 187.1 6.3-1-3.4-26.8-86.7-7.7-111.9 16.7-22 48.6 29.1 92.5 29.1C550.2 417.9 576 377.6 576 336c0-42.8-26.2-80-69.4-80zm1.5 129.9c-30 0-41.4-33.9-81.5-33.9-53.6 0-54.8 65-44.3 117.8-36.4 3.4-107 16.4-124.9 .6C237.3 452.6 288 428.3 288 384c0-37.7-33.3-64-81-64-75 0-102.9 59.8-56.2 122 4.7 6.3 9.2 12.2 9.2 15.8 0 33.7-94 20.6-128 13.9V192c63.3 11.7 160 18.1 160-46.5 0-28.6-30-43-30-76.6C162.1 44.1 190.3 32 214.8 32c20 0 43.4 9.2 43.4 35.3 0 29.4-34.3 40.8-34.3 80.6 0 57.8 100.8 50.9 158.2 43.1C374.1 245.3 374 320 429.1 320c29.1 0 43.7-32 77.5-32C531.5 288 544 311.3 544 336c0 34.4-21 49.9-35.9 49.9z"}})])
          )
        }
      }
    